export const getDefaultDate = () => new Date().toISOString();
